export default {
  pageTransitionDuration: 600,
};
